<script lang="ts">
    
    import { createEventDispatcher, getContext, onMount } from "svelte";
    import type { ChatBotElement, SaveGame } from "../../global";
    import type { ChatActivity } from "../../Model/ChatActivity";
    import { addPoints, quitPoints } from "../../Services/game";
    import { getPlayer } from "../../Services/playerRepository";
    import ActiviyModal from "../Shared/ActiviyModal.svelte";
    import FailScreen from "../Shared/FailScreen.svelte";
    import WinScreen from "../Shared/WinScreen.svelte";

    export let activity: ChatActivity;

    const dispatch = createEventDispatcher();
    const saveGame: SaveGame = getContext('saveGame');

    let chatBot: ChatBotElement;
    let showWinScreen = false;
    let showFailScreen = false;
    let points = 0;

    onMount(async () => {
        const chatConf = await getChatConf(activity.src);
        chatBot.addEventListener('chatbot:node_added', onNodeAdded);
        chatBot.setChatConf(chatConf);
    });

    async function getChatConf(src: string): Promise<any> {
        const response = await fetch(src);
        const json = await response.text();
        const { name } = getPlayer();
        return JSON.parse(json.replaceAll('{playerName}', name));
    }

    function onNodeAdded(event: CustomEvent): void {

        const chatNode = event.detail;
        const chatEvent = activity.getChatEventByNodeId(chatNode.id);
        
        if (chatEvent?.success) {
            if (!activity.isCompleted.value) {
                points = activity.points.win;
            }
            setCompletedAndSave();
            setTimeout(() => showWinScreen = true, 1000);
            return;
        }

        if (!chatNode.options?.length) {
            //El nodo no tiene opciones
            //Consideramos que el usuario ha "fallado" la conversación
            points = activity.points.fail;
            quitPoints(activity.points.fail);
            setTimeout(() => showFailScreen = true, 1000);
        }
    }

    function onContinue(): void {
        dispatch('close');
    }

    function setCompletedAndSave(): void {
        if (activity.isCompleted.value) {
            return;
        }
        addPoints(activity.points.win);
        activity.setCompleted();
        saveGame();
    }

</script>

<ActiviyModal on:close title={activity.title}>
    <div class="chat-background">
        <chat-bot src={activity.src} bind:this={chatBot} noinput></chat-bot>
    </div>
</ActiviyModal>

{#if showWinScreen}
    <WinScreen {points} on:continue={onContinue} />
{/if}

{#if showFailScreen}
    <FailScreen {points} on:continue={onContinue} />
{/if}

<style lang="scss">

    .chat-background {
        height: 100%;
        background-color: #E4E4E4;
        background-image: url('/images/tile-chat.png');
        background-size: 60px 60px;
        background-repeat: repeat;
    }

</style>
